
import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel
} from "@/components/ui/form"
import { Input } from "@/components/ui/input";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { Dropdown } from '../ui/filterSelect';
import { TagBox } from "../ui/tagbox";
import { Checkbox } from "@/components/ui/checkbox";
import { Popup } from "@/components/common/Popup";
import { AgendaItemInfo } from "@/components/agenda/AgendaItemInfo";


import { Trash2 } from "lucide-react";
import { useApiFetch } from "@/helper/apiFetch";
import { AgendaSchema, AgendaItemInfoSchema } from "./AgendaSchema";
import { PlenumInfoSchema } from "@/components/plenum/PlenumSchema";
import { Toggle } from "../ui/toggle";
type AgendaInfoProps = {
  Id?: number;
  eventId: string;
  onClose: (agenda: z.infer<typeof AgendaSchema>|null) => void;
};



type Lookup = { Id: string; Description: string };




export function AgendaInfo({ Id, eventId, onClose }: AgendaInfoProps) {
  const apiFetch = useApiFetch();
  //coded for admin only, no customer should be in this screen changing orders
  const [isLoaded, setIsLoaded] = useState(false);
  const [timezones, setTimezones] = useState<Lookup[]>([]);
  const [plenums, setPlenums] = useState<PlenumInfoSchema[]>([]);
  const [items, setItems] = useState<AgendaItemInfoSchema[]>([]);
  const [editItem, setItem] = useState<number|null>(null);
  const [errorText, setError] = useState("");

  const formatWallClock = (value: unknown) => {
    if (!value) return "";
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      const pad = (n: number) => String(n).padStart(2, "0");
      return `${pad(value.getDate())}/${pad(value.getMonth() + 1)}/${value.getFullYear()} ${pad(value.getHours())}:${pad(value.getMinutes())}`;
    }
    if (typeof value !== "string") return "";

    const m = value.match(/^(\d{4})-(\d{2})-(\d{2})(?:[T\s](\d{2}):(\d{2}))?/);
    if (!m) return value;

    const day = m[3];
    const month = m[2];
    const year = m[1];
    const hour = m[4] ?? "00";
    const minute = m[5] ?? "00";
    return `${day}/${month}/${year} ${hour}:${minute}`;
  };


  const form = useForm<z.infer<typeof AgendaSchema>>({
    resolver: zodResolver(AgendaSchema),
    defaultValues: {
      EventId: eventId
      

    }
  });


const AddItem = () => {

  if( Id == null || Id == undefined || Id < 0) {
    Save(form.getValues(), false).then(() => {
      setItem(-1);
    });
  }
  else
    setItem(-1);
}
const setAgendaItemVisible = async (itemId: number | null, visible: boolean) => {
  if(itemId == null) return;

  try {
    setError("");
    const value = { Visible: visible };
    const fd = new FormData();
    fd.append("key", String(itemId));
    fd.append("values", JSON.stringify(value));
    const res = await apiFetch(`/api/EventPool/PutAgendaItem`, {
      method: "PUT",
      body: fd
    });

    if (!res.ok) {
      const e = await res.text();
      setError(e);
    }
    else {
      setItems((prev) => prev.map((item) => item.Id === itemId ? { ...item, Visible: visible } : item));
    }
  } catch (err) {
    console.error(err);
  }
}

  const onSubmit = async (values: z.infer<typeof AgendaSchema>) => {
    Save(values, true);
  }
  const Save = async (values: z.infer<typeof AgendaSchema>, closeAfterSave: boolean) => {
try {
      setError("");

      
      const res = await apiFetch(`/Admin/SaveAgendaGroup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });

      if (!res.ok) {
        const e = await res.text();
        setError( e);

      }
      else {

       

        if (closeAfterSave) {
          onClose( values);
        }
        else
        {
            const temp=await res.text();
            Id = Number(temp);
            form.setValue("Id", Id);
        }

      }
    } catch (err) {
      console.error(err);
    }
  }

  const LoadItems = async () => {

 apiFetch(`/api/EventPool/GetAgendaItems?agendaGroupId=${Id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch agenda items");
        return res.json();
      })
      .then((data) => {
        setItems(data ?? []);
      })
      .catch((err) => {
        console.error(err);
      });

  }
  useEffect(() => {
if((Id??0) <= 0 || Id == undefined) {
  setIsLoaded(true);
  return;
}


    apiFetch(`/Admin/GetAgendaGroup?agendaGroupId=${Id}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch agenda group");
        return res.json();
      })
      .then((data) => {
        form.reset(data);
        setIsLoaded(true);
      })
      .catch((err) => {
        console.error(err);
      });

     LoadItems();


  }, []);

 
  useEffect(() => {



    apiFetch(`/api/EventPool/GetTimeZones`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch time zones");
        return res.json();
      })
      .then((data) => {
      
        setTimezones(data.data);
      })
      .catch((err) => {
        console.error(err);
      });


      apiFetch(`/api/EventPool/GetPlenumListByEvent?isMarketPlace=false&eventId=${eventId}`)
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch time zones");
        return res.json();
      })
      .then((data) => {
      
        setPlenums(data.data);
      })
      .catch((err) => {
        console.error(err);
      });




  }, [isLoaded]);



  return (
    <div className="p-5">
      {!isLoaded ? (
        <div>Loading…</div>
      ) : (
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit, (error) => { console.log("Validation errors:", error, form.getValues()); })} className="space-y-2">
            <div className="grid grid-cols-3 gap-6">


              <FormField
                control={form.control}
                name="TabName"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Tab Name (optional, if none given, agenda groups will show as list)</FormLabel>
                    <FormControl>
                       <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />
      <FormField
                control={form.control}
                name="Date"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Date (type in as you want it displayed)</FormLabel>
                    <FormControl>
                       <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />
  <FormField
                                                         control={form.control}
                                                         name="TimeZones"
                                                         render={({ field }) => (
                                                           <FormItem className="">
                                                             <FormLabel>Time Zones (optional)</FormLabel>
                                                             <FormControl>
                                                            <TagBox
                                                                 source={timezones}
                                                                 value={field.value}
                                                                 getLabel={(x) => x.Description}
                                                                 getValue={(x) => x.Id}
                                                                 onChange={field.onChange }
             
                                                                />
                                                             </FormControl>
                                                           </FormItem>
                                                         )}
                                                       />
 <FormField
                control={form.control}
                name="Title"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Title </FormLabel>
                    <FormControl>
                       <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />

               <FormField
                control={form.control}
                name="SubTitle"
                render={({ field }) => (
                  <FormItem className="col-span-2">
                    <FormLabel>Subtitle (optional)</FormLabel>
                    <FormControl>
                       <Input {...field} />
                    </FormControl>
                  </FormItem>
                )}
              />
             

           
              </div>
              <div className="grid grid-cols-3 gap-6">

                <div className="border-b border-black col-span-3 mt-4 ">Agenda Items

                <Button className="float-right" type="button" onClick={() => { AddItem() }}>Add Item</Button>
        
                </div>
                

  <FormField
                                  control={form.control}
                                  name="ShowInOneBlock"
                                  render={({ field }) => (
                                    <FormItem className="">
                                      <FormControl>
                                        <Checkbox
                                          label="Show items in one combined block"
                                          checked={!!field.value}
                                          onCheckedChange={field.onChange}
                                          name={field.name}
                                          onBlur={field.onBlur}
                                          ref={field.ref}
                                        />
                                      </FormControl>
                                    </FormItem>
                                  )}
                                />

                                {!form.watch("ShowInOneBlock") && (

                                   <FormField
                                  control={form.control}
                                  name="ShowICS"
                                  render={({ field }) => (
                                    <FormItem className="">
                                      <FormControl>
                                        <Checkbox
                                          label="Show ICS download for each item"
                                          checked={!!field.value}
                                          onCheckedChange={field.onChange}
                                          name={field.name}
                                          onBlur={field.onBlur}
                                          ref={field.ref}
                                        />
                                      </FormControl>
                                    </FormItem>
                                  )}
                                />
                                )}

                                    {form.watch("ShowInOneBlock") && (

                                <FormField
                                  control={form.control}
                                  name="PlenumId"
                                  render={({ field }) => (
                                    <FormItem className="">
                                      <FormLabel>Show Watch button on top for Plenum:</FormLabel>
                                      <FormControl>
                                        <Dropdown
                                          source={plenums}
                                          value={field.value}
                                          getLabel={(x) => x.Name??""}
                                          getValue={(x) => x.Id??0}
                                          onChange={field.onChange}
                                          searchable={true}
                                        />
                                      </FormControl>
                                    </FormItem>
                                  )}
                                />



                                
                                )}
           
            </div>
           


          

            

 <div className="rounded-md border !mt-5">
        {/* <div className="border-b bg-slate-100 px-3 py-2 text-sm font-bold text-gray-600">Agenda Items</div> */}
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead className="bg-slate-50 text-left">
              <tr>
                <th className="px-3 py-2 font-medium text-gray-600">Visible</th>
                <th className="px-3 py-2 font-medium text-gray-600">Item Type</th>
                <th className="px-3 py-2 font-medium text-gray-600">Start</th>
                <th className="px-3 py-2 font-medium text-gray-600">End</th>
                <th className="px-3 py-2 font-medium text-gray-600">Title</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {items?.length === 0 ? (
                <tr className="border-t">
                  <td colSpan={6} className="px-3 py-4 text-center text-gray-500">
                    No agenda items yet
                  </td>
                </tr>
              ) : (
                items?.map((item) => (
                  <tr key={item.Id} className="border-t align-middle" onClick={() => setItem(item.Id??null)} style={{ cursor: "pointer" }}>
                    <td className="px-3 py-2" onClick={(e) => e.stopPropagation()}><Toggle checked={item.Visible} onChange={(e) => { setAgendaItemVisible(item.Id??0, e.target.checked) }} /></td>
                    <td className="px-3 py-2">{item.AgendaItemType==0?"Custom":item.AgendaItemType==1?"Plenum":"Networking"}</td>
                    <td className="px-3 py-2">{formatWallClock(item.DateFrom)}</td>
                    <td className="px-3 py-2">{formatWallClock(item.DateTo)}</td>
                    <td className="px-3 py-2">{item.Title}</td>
                    <td className="px-3 py-2">
                      <div className="flex items-center gap-2">
                        <Button type="button" variant="outline" size="icon" title="Delete item" aria-label="Delete item">
                          <Trash2 className="h-4 w-4" aria-hidden="true" />
                        </Button>
                      </div>
                    </td>
                   
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>


            <div className="grid-default">
              <div></div>
              <div className="grid-default">
                <Button className="w-full" type="button" onClick={() => { console.log("Cancel clicked"); onClose(null); }}>Cancel</Button>

                <Button className="w-full" type="submit">Save</Button>
              </div>
            </div>
            {(errorText != "") && (
              <div className="text-red-500 mt-2">
                {errorText}
              </div>
            )
            }
          </form>
        </Form>)}



        <Popup isOpen={editItem != null} onClose={() => { setItem(null); }} title="Agenda Item" className="w-[95vw] max-w-6xl">
          <AgendaItemInfo Id={editItem??-1} agendaGroupId={Id??-1} eventId={eventId} plenums={plenums} onClose={(saved) => { setItem(null); if (saved) { LoadItems(); } }} />
        </Popup>
     
    </div>

  )
}



